(() => {
  const start = () => {
    const page = document.querySelector('.oral-niacinamide-foam');
    if (!page || new URL(location.href).searchParams.has('variant')) return;
    const preferred = [...page.querySelectorAll('variant-selects input[type="radio"]')].find(input => input.value.trim().toUpperCase() === 'BUY 3');
    if (preferred && !preferred.checked) preferred.click();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
